import API from '../';
import { HTTP_METHODS } from '../helpers/methods-helpers';

class OrderOfTheDayAPI extends API {
	getPointsOrderOfTheDay(session) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/puntos-orden-dia/sesion/${session}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getOrderOfTheDay(session) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/sesion/${session}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	setOrderOfTheDay(session) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/sesion/${session}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
}

export const orderOfTheDayAPI = new OrderOfTheDayAPI('/ordenDia');
export const IntegrateToOrderApi = new API('/integracion-orden-dia');
export const DeleteResolutionToOrderApi = new API(
	'/integracion-orden-dia/eliminar-resoluciones'
);
